var React = require('react');

function InstagramInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"clipRule":"evenodd","d":"m0 7.68182c0-4.23682 3.445-7.68182 7.68182-7.68182h10.63638c4.2368 0 7.6818 3.445 7.6818 7.68182v10.63638c0 4.2368-3.445 7.6818-7.6818 7.6818h-10.63638c-4.23682 0-7.68182-3.445-7.68182-7.6818zm21.2727-1.77273c0-.65-.5318-1.18182-1.1818-1.18182s-1.1818.53182-1.1818 1.18182.5318 1.18182 1.1818 1.18182 1.1818-.53182 1.1818-1.18182zm-8.2727.59091c3.5868 0 6.5 2.91318 6.5 6.5 0 3.5868-2.9132 6.5-6.5 6.5-3.58682 0-6.5-2.9132-6.5-6.5 0-3.58682 2.91318-6.5 6.5-6.5zm-5.31818 6.5c0-2.9309 2.38728-5.31818 5.31818-5.31818s5.3182 2.38728 5.3182 5.31818-2.3873 5.3182-5.3182 5.3182-5.31818-2.3873-5.31818-5.3182z","fill":"#3f3f3f","fillRule":"evenodd"}));
}

InstagramInline.defaultProps = {"fill":"none","height":"26","viewBox":"0 0 26 26","width":"26"};

module.exports = InstagramInline;

InstagramInline.default = InstagramInline;
